import { Accessory } from "Types/api/Accessory";
import { CreditAppStatuses } from "Types/creditApp";

export type Steps = 1 | 2 | 3;

export function calculateNextStep(
    hasAvailableAccessories: boolean,
    creditAppStatus: CreditAppStatuses | null | undefined,
    accessoriesSkipped: boolean,
    vehicle: { vin: string; accessories?: Accessory[] }
): Steps {
    const selectedAccessories = vehicle && vehicle.accessories && vehicle.accessories.length > 0;

    if (creditAppStatus == null) {
        return 1;
    }

    if (!hasAvailableAccessories) {
        return 2;
    }

    if (selectedAccessories || accessoriesSkipped) {
        return 3;
    }

    return 2;
}
